import { useState } from 'react';

import { usePromotePageData } from 'src/app/pages/promote/pageContext';
import { useTrackView } from 'src/app/shared/hooks/tracking';

export function useTrackFormView(loadingStartTime: number): void {
	const {
		data: {
			petition: { geoReach, categoryTags, relevantLocationLocalizedName, bandits },
			comboBanditData: { variant } = {},
		},
	} = usePromotePageData();

	const [time] = useState(() => Math.ceil(performance.now() - loadingStartTime));

	useTrackView('pp_form_loading_time', { time });
	useTrackView('pp_form_view', {
		geo_reach: geoReach ?? undefined,
		category_tags: categoryTags,
		relevant_location_localized_name: relevantLocationLocalizedName ?? undefined,
		combo_bandit_variant: variant?.variantName ?? undefined,
		combo_bandit_value: variant?.data.amount,
		promoted_bandit_variant_shown_value:
			bandits?.contextualPromotionButtons?.selectedVariant?.data.amounts ?? undefined,
	});
}
